import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumAccountPostingLineType implements BaseEnumType {
  private static allValues: EnumAccountPostingLineType[] = []; // make sure this is top-most
  
  public static order = new EnumAccountPostingLineType(0, "Order", "enum_account_posting_line_type_order");
  public static credit = new EnumAccountPostingLineType(1, "Credit", "enum_account_posting_line_type_credit");
  public static outlet = new EnumAccountPostingLineType(2, "Outlet", "enum_account_posting_line_type_outlet");
  public static stockItem = new EnumAccountPostingLineType(3, "StockItem", "enum_account_posting_line_type_stock_item");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumAccountPostingLineType.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isOrder() { return this === EnumAccountPostingLineType.order; }
  public isCredit() { return this === EnumAccountPostingLineType.credit; }
  public isOutlet() { return this === EnumAccountPostingLineType.outlet; }
  public isStockItem() { return this === EnumAccountPostingLineType.stockItem; }

  public static getValues(): readonly EnumAccountPostingLineType[] {
    return EnumAccountPostingLineType.allValues;
  }

  public static getValuesExcept0(): readonly EnumAccountPostingLineType[] {
    return EnumAccountPostingLineType.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumAccountPostingLineType {
    const found = EnumAccountPostingLineType.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumAccountPostingLineType - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumAccountPostingLineType): EnumAccountPostingLineType {
    const found = name ? EnumAccountPostingLineType.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumAccountPostingLineType - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumAccountPostingLineType>): boolean {
    return this.key === other?.key;
  }
}